import React from 'react'
import { Button, Space, TimePicker, message } from 'antd'
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons'
import moment, { Moment } from 'moment'

interface CallTimePeriod {
  startTime: string
  endTime: string
}

interface CallTimePeriodsProps {
  value?: CallTimePeriod[]
  onChange?: (value: CallTimePeriod[]) => void
}

const CallTimePeriods: React.FC<CallTimePeriodsProps> = ({ value = [], onChange }) => {
  const handleAdd = () => {
    const newPeriod: CallTimePeriod = {
      startTime: '09:00:00',
      endTime: '18:00:00',
    }
    onChange?.([...value, newPeriod])
  }

  const handleRemove = (index: number) => {
    const newValue = value.filter((_, i) => i !== index)
    onChange?.(newValue)
  }

  const handleTimeChange = (index: number, timeRange: [Moment | null, Moment | null] | null) => {
    if (!timeRange || !timeRange[0] || !timeRange[1]) {
      return
    }

    const startTime = timeRange[0].format('HH:mm') + ':00'
    const endTime = timeRange[1].format('HH:mm') + ':00'

    // 检查是否与其他时段重复
    const hasOverlap = value.some((period, i) => {
      if (i === index) return false
      const currentStart = startTime
      const currentEnd = endTime
      const existStart = period.startTime
      const existEnd = period.endTime

      return !(currentEnd <= existStart || currentStart >= existEnd)
    })

    if (hasOverlap) {
      message.warning('时间段不能重复')
      return
    }

    const newValue = [...value]
    newValue[index] = { startTime, endTime }
    onChange?.(newValue)
  }

  return (
    <div>
      <Space direction="vertical" style={{ width: '100%' }}>
        {value.map((period, index) => (
          <Space key={index} align="center">
            <TimePicker.RangePicker
              format="HH:mm"
              value={[
                moment(period.startTime, 'HH:mm:ss'),
                moment(period.endTime, 'HH:mm:ss'),
              ]}
              onChange={(times) => handleTimeChange(index, times)}
            />
            {value.length > 1 && (
              <MinusCircleOutlined
                style={{ color: '#ff4d4f', cursor: 'pointer' }}
                onClick={() => handleRemove(index)}
              />
            )}
          </Space>
        ))}
      </Space>
      <Button
        type="dashed"
        onClick={handleAdd}
        icon={<PlusOutlined />}
        style={{ marginTop: 8 }}
      >
        新增时段
      </Button>
    </div>
  )
}

export default CallTimePeriods
